module.exports = __webpack_public_path__ + "static/Screenshot (67)-11011b9f6f845e35adc04ad4a290c73f.png";